<span class="tag" *ngIf="labels && labels.length"
[ngClass]="{'premiere': labels[0].isPremiere}">
  {{ labels[0].value | translate }}
</span>
<ng-content></ng-content>